import { createStore } from '../.'

import type { StateStorage } from 'zustand/middleware'
import { NFT, type NFTCollection } from '../../interfaces/common'

interface UserNftBalanceStore {
  nftBalances: { [key: string]: NFTCollection[] }
  nftsBalancesForWallet: (walletId: string) => NFTCollection[]
  setNftBalances: (walletId: string, nfts: NFTCollection[]) => void
  removeNft: (walletId: string, nft: NFT) => void
}

export const createNftBalancesStore = (storage: StateStorage) =>
  createStore<UserNftBalanceStore>(
    storage,
    (set, get) => ({
      nftBalances: {},
      nftsBalancesForWallet(walletId) {
        return get().nftBalances[walletId] || []
      },
      setNftBalances(walletId, nfts) {
        const { nftBalances } = get()
        set({
          nftBalances: { ...nftBalances, [walletId]: nfts },
        })
      },
      removeNft: (walletId: string, nft: NFT) => {
        const { nftBalances } = get()

        const walletCollections = nftBalances[walletId]
        let changedCollection = walletCollections.find(
          (collection) => collection.canisterId === nft.collection
        )

        if (changedCollection) {
          const identifier = nft.standard === 'ordinal' ? nft.id : nft.index

          changedCollection.nfts = changedCollection.nfts.filter(
            (oldNft) => (oldNft.standard === 'ordinal' ? oldNft.id : oldNft.index) !== identifier
          )
        }

        set({
          nftBalances: {
            ...nftBalances,
            [walletId]: [
              ...walletCollections.filter((c) => c.canisterId !== nft.collection),
              changedCollection,
            ]
              .filter((c) => !!c)
              .filter((c) => c.nfts.length),
          },
        })
      },
    }),
    {
      persist: {
        name: 'userNftBalance',
        version: 1,
      },
    }
  )
